import React, { useState } from 'react';
import './App.css';

import { Memory, Welcome } from './Memory';
import classnames from 'classnames';
import { strings } from './Localization';
// Restore saved language
try {
  if (window.localStorage.language !== undefined) {
    strings.setLanguage(window.localStorage.language);
  }
} catch (err) {}
function App() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [dept, setDept] = useState();
  const [language, setLanguage] = React.useState(
    window.localStorage.language !== undefined
      ? window.localStorage.language
      : strings.getLanguage()
  );
  const handleSelectDept = (dept) => () => {
    setDept(dept);
    setMobileMenuOpen(false);
  };
  const handleChangeLanguage = (lang) => {
    setLanguage(lang);
    strings.setLanguage(lang);
    localStorage.language = lang;
  };
  const renderNavigation = (renderTitle = true) => {
    return (
      <>
        <div className="Navigation">
          {renderTitle === true && (
            <div className="MenuTitle">{strings.chooseTeam}</div>
          )}
          <div
            className={classnames('Button', {
              ButtonSelected: dept === 'TERRESTRE NACIONAL',
            })}
            onClick={handleSelectDept('TERRESTRE NACIONAL')}
          >
            {strings.nationalLand}
          </div>
          <div
            className={classnames('Button', {
              ButtonSelected: dept === 'TERRESTRE INTERNACIONAL',
            })}
            onClick={handleSelectDept('TERRESTRE INTERNACIONAL')}
          >
            {strings.internationalLand}
          </div>
          <div
            className={classnames('Button', {
              ButtonSelected: dept === 'AIR & OCEAN',
            })}
            onClick={handleSelectDept('AIR & OCEAN')}
          >
            {strings.airOcean}
          </div>
          <div
            className={classnames('Button', {
              ButtonSelected: dept === 'ALMACÉN',
            })}
            onClick={handleSelectDept('ALMACÉN')}
          >
            {strings.warehouse}
          </div>
        </div>
        <div>
          {language !== 'es' && (
            <div
              className={'Button'}
              onClick={() => handleChangeLanguage('es')}
            >
              {strings.spanish}
            </div>
          )}
          {language !== 'en' && (
            <div
              className={'Button'}
              onClick={() => handleChangeLanguage('en')}
            >
              {strings.english}
            </div>
          )}
        </div>
      </>
    );
  };
  return (
    <div className="App">
      <div
        className={classnames('MobileMenuButton', {
          MobileMenuButtonSelected: mobileMenuOpen,
        })}
        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
      ></div>
      <div
        className={classnames('MobileMenu', {
          MobileMenuOpen: mobileMenuOpen,
        })}
      >
        <div className="Logo"></div>
        {renderNavigation()}
      </div>
      <div className="Background">
        <div className="Menu">
          <div className="Logo"></div>
          {renderNavigation()}
        </div>

        {dept ? (
          <Memory dept={dept} onReset={() => setDept(undefined)} />
        ) : (
          <Welcome
            logo={<div className="Logo MobileOnly"></div>}
            menu={renderNavigation(false)}
          />
        )}
      </div>
    </div>
  );
}

export default App;
